import Dialog, { DialogProps } from "@mui/material/Dialog"
import { Box, DialogContent, DialogTitle, IconButton } from "@mui/material"
import { COLORS } from "../../utils/constants/theme/colors"
import { useRef, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"

interface ModalProps {
  children: React.ReactNode
  title?: string
  maxWidths?: DialogProps["maxWidth"]
  trigger: boolean
  setTriggerFnc: React.Dispatch<React.SetStateAction<boolean>>
  closeOnOutsideClick?: boolean
  notCloseOnOutside?: boolean
  icon?: boolean
  iconClick?: Function | any
  modalClass?: string
  containerClass?: string
}

const ModalPopup = ({
  children,
  title,
  trigger,
  setTriggerFnc,
  closeOnOutsideClick = true,
  notCloseOnOutside,
  maxWidths,
  icon,
  iconClick,
  modalClass,
  containerClass,
}: ModalProps) => {
  const dialogRef = useRef(null)
  const [outside, setOutside] = useState(false)

  const handleClose = () => {
    if (closeOnOutsideClick) {
      setTriggerFnc(false)
    }
  }

  return (
    <Dialog
      className={containerClass}
      onClose={notCloseOnOutside ? () => setOutside(true) : handleClose}
      open={trigger}
      PaperProps={{
        ref: dialogRef,
        className: modalClass,
        style: {
          borderRadius: "12px",
          backgroundColor: COLORS.surfaceDark,
        },
      }}
      maxWidth={maxWidths}
    >
      <Box sx={{ backgroundColor: COLORS.surfaceDark, borderBottom: `1px solid #FFFFFF33`}} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignContent={"center"} alignItems={"center"}>
        {title && <DialogTitle color={COLORS?.textPrimary} fontSize='22px' fontWeight='400'>{title}</DialogTitle>}
        {icon && (
          <IconButton onClick={iconClick}>
            <CloseIcon sx={{ color: "white", mx: 1 }} />
          </IconButton>
        )}
      </Box>

      <DialogContent sx={{background: COLORS.surfaceDark,}}>{children}</DialogContent>
    </Dialog>
  )
}

export default ModalPopup
